module.exports = __webpack_public_path__ + "static/media/show_logo.f5b9a461.png";